import { combineReducers } from 'redux';
import languageReducer from './languageReducer';
import formOptionReducer from './formOptionReducer';
import authReducer from './authReducer';
import stepsReducer from './stepsReducer';
import applicantRootReducer from './applicantReducer';
import agreementReducer from './agreementReducer';
import catalogueReducer from './catalogueReducer';
// import { ACTION_TYPE } from '../actions/actionTypes';

const appReducer = combineReducers({
  languageReducer,
  formOptionReducer,
  authReducer,
  stepsReducer,
  applicantRootReducer,
  agreementReducer,
  catalogueReducer,
});

const rootReducer = (state, action) => {
  let modifiedState = state;
  if (action.type === 'LOAD_STATE') {
    // console.log('modifiedState', modifiedState);
    modifiedState = {
      ...state,
      applicantRootReducer: {
        ...state.applicantRootReducer,
        ...action.stateFile,
      },
    };
  }
  return appReducer(modifiedState, action);
};

export default rootReducer;
